// ES
export const propCreateHc = {
  firstCreate: {
    // Tipos de alojamiento
    typeApartmentLabel: `Apartamento`,
    typeApartmentDesc: `Alojamiento amueblado e independiente que se alquila entero.`,
    typeVillaLabel: `Villa o casa`,
    typeVillaDesc: `Casas, villas y chalets que se alquilan completos.`,
    typeHotelLabel: `Hotel, hostal o B&B`,
    typeHotelDesc: `Alojamientos que gestionan varias habitaciones.`,
    typeCampingLabel: `Camping`,
    typeCampingDesc: `Campings y parcelas con varias plazas o unidades.`,

    // Sustantivos de establecimiento / unidad
    venueHotel: `hotel`,
    venueCamping: `camping`,
    roomHotel: `habitación`,
    roomCamping: `parcela`,
    roomHotelPlural: `habitaciones`,
    roomCampingPlural: `parcelas`,
    yourVenue: `tu {venue}`,

    // Botones comunes
    back: `Atrás`,
    continue: `Continuar`,

    // Paso: tipo
    typeTitle: `¡Demos de alta tu alojamiento!`,
    typeSubtitle: `Para empezar, elige el tipo de alojamiento que quieres publicar.`,

    // Paso: cantidad
    quantityTitle: `¿Cuántos alojamientos quieres dar de alta?`,
    quantitySubtitle: `Puedes empezar con uno o crear varios de una vez.`,
    oneTitle: `1 alojamiento`,
    oneDesc: `Solo quiero publicar uno por ahora.`,
    manyTitle: `Más de 1 alojamiento`,
    manyDesc: `Tengo varios para dar de alta.`,

    // Paso: ubicación (mismo edificio o no)
    locationTitle: `¿Están en el mismo edificio o dirección?`,
    locationSubtitle: `Esto nos ayuda a organizar tus alojamientos de la mejor forma.`,
    sameBuildingYesTitle: `Sí, en el mismo edificio o dirección`,
    sameBuildingYesDesc: `Se agruparán en un único anuncio con varias unidades.`,
    sameBuildingNoTitle: `No, en direcciones diferentes`,
    sameBuildingNoDesc: `Cada uno será un anuncio independiente (lo configuras después).`,

    // Paso: nombres (títulos y subtítulos dinámicos)
    namesTitleAttach: `Añade una unidad a tu anuncio`,
    namesTitleHotel: `¿Cómo se llama tu {venue}?`,
    namesTitleGrouped: `Ponle nombre a cada unidad`,
    namesTitleList: `Ponle nombre a cada alojamiento`,
    namesTitleDefault: `¿Cómo se llama tu alojamiento?`,
    namesSubAttach: `Se añadirá como una unidad nueva dentro de “{name}”.`,
    yourListing: `tu anuncio`,
    namesSubHotel: `Es el nombre que verán tus huéspedes. En el siguiente paso añades los tipos de {room}.`,
    namesSubGrouped: `Cada unidad tendrá su propio calendario dentro del mismo anuncio.`,
    namesSubList: `Cada uno será un anuncio independiente con su propia configuración.`,
    namesSubDefault: `Es el nombre que verán tus huéspedes. Podrás cambiarlo cuando quieras.`,
    addUnitLabel: `Añadir otra unidad`,
    addListingLabel: `Añadir otro alojamiento`,

    // Card del anuncio principal (agrupado)
    mainListingEyebrow: `Anuncio principal`,
    mainListingSub: `Agrupa todas las unidades de este edificio en un solo anuncio.`,
    mainListingNameLabel: `Nombre del alojamiento principal`,
    mainListingNamePlaceholder: `Ej: Residencial Bilbao`,
    mainListingNameHint: `Edificio, torre o ubicación que agrupa las unidades.`,
    currency: `Moneda`,
    currencyHintUnit: `Tarifa por noche de cada unidad.`,

    // Cards de unidad
    unitNameLabel: `Nombre de la unidad`,
    listingNameLabel: `Nombre del alojamiento`,
    phRoomCamping: `Ej: Camping Pinar del Mar`,
    phRoomHotel: `Ej: Hotel Costa Azul`,
    phAttach: `Ej: Luxury estudio en Playa Roca, 1ª línea de mar`,
    phGrouped: `Ej: Apartamento {n}A`,
    phList: `Alojamiento {n}`,
    phDefault: `Ej: Apartamento Centro`,
    remove: `Quitar`,
    internalNameOptional: `Nombre interno (opcional)`,
    pricePerNight: `Precio / noche`,
    currencyHintHotel: `Todas las {rooms} usan esta moneda.`,

    // Nombre interno (caso de un único nombre)
    internalNameLabel: `Nombre interno`,
    optional: `(opcional)`,
    internalNamePlaceholderSingle: `Ej: Apto reformas 2024 / llaves conserjería`,
    internalNameHint: `Solo lo ves tú, para identificarlo internamente. No se muestra a los huéspedes.`,

    // Paso: tipos de habitación (hotel/camping)
    roomsTitle: `¿Qué {rooms} tiene {venue}?`,
    roomsSubtitle: `Añade cada tipo de {room} con su cantidad y su precio por noche. Podrás editarlo cuando quieras.`,
    roomTypeLabel: `Tipo de {room}`,
    phRoomTypeCamping: `Ej: Parcela con electricidad`,
    phRoomTypeHotel: `Ej: Habitación doble deluxe`,
    quantity: `Cantidad`,
    addRoomType: `Añadir tipo de {room}`,

    // Paso: dirección
    addressTitle: `¿Dónde está tu alojamiento?`,
    addressSubtitle: `Empieza a escribir y elige la dirección. La usamos para el mapa y el check-in.`,
    country: `País`,
    countryHint: `Buscaremos direcciones solo dentro de este país.`,
    address: `Dirección`,
    addressPlaceholder: `Calle, número, ciudad…`,
    addressPlaceholderNoCountry: `Primero elige el país`,
    city: `Ciudad`,
    zipCode: `Código postal`,

    // Paso: tarifa
    priceTitle: `Tu tarifa estándar por noche`,
    priceSubtitle: `Es tu precio base. Luego podrás ajustarlo por temporada o por portal.`,
    priceLabel: `Precio por noche`,
    perNight: `/ noche`,
    priceHint: `Puedes cambiarlo cuando quieras desde el panel.`,

    // Botón primario y razón de creación
    createUnit: `Añadir unidad`,
    createVenue: `Crear mi {venue}`,
    createListingsPlural: `Crear mi alojamiento | Crear mis {count} alojamientos`,
    reasonUnit: `unidad`,
    reasonListing: `anuncio`,

    // Toasts / validación
    toastCompleteToContinue: `Completa los datos para continuar.`,
    toastCompleteNames: `Completa el nombre de cada alojamiento.`,
    toastCompleteLocation: `Completa la ubicación.`,
    toastCompleteRooms: `Completa cada habitación: nombre, cantidad y precio por noche.`,
    toastRoomRatePerUnit: `Indica la tarifa por noche de cada unidad.`,
    toastCompleteRate: `Completa la tarifa por noche.`,
    toastCreatedPlural: `¡Alojamiento creado! | ¡Alojamientos creados!`,
    toastCreateError: `No pudimos crear el alojamiento. Inténtalo de nuevo.`,
  },

  welcome: {
    // Títulos de cabecera
    arrivalTitleCaps: `Instrucciones de Llegada`,
    arrivalTitle: `Instrucciones de llegada`,
    arrivalSubtitle: `Mensaje que recibe el huésped el día de su llegada.`,
    welcomeTitle: `Mensaje de bienvenida`,
    welcomeSubtitle: `Mensaje que recibe el huésped tras completar su registro.`,
    loadingMessages: `Cargando mensajes...`,

    // Bienvenida por habitación
    roomWelcomeTitle: `Mensaje de bienvenida de esta habitación`,
    roomWelcomeSub: `Si lo dejas vacío, se envía el mensaje de bienvenida general del hotel. El interruptor, los adjuntos y la OTA se configuran a nivel de hotel.`,

    // Interruptor bienvenida
    welcomeEnableTitle: `Enviar mensaje de bienvenida`,
    welcomeEnableSub: `El huésped lo recibe tras completar su registro. Si lo apagas, no se enviará.`,

    // Clonar
    clone: `Clonar`,
    clonePullTitle: `Traer configuración de otro alojamiento`,
    clonePullSub: `Importa la bienvenida de otro a este`,
    clonePushTitle: `Copiar esta configuración a otro alojamiento`,
    clonePushSub: `Aplica esta bienvenida a otros`,
    cloneModalPullTitle: `Traer configuración de bienvenida`,
    cloneModalPushTitle: `Copiar mensaje de bienvenida`,
    cloneModalPullSubtitle: `Elige el alojamiento del que quieres traer la configuración. Se aplicará a este anuncio.`,
    cloneModalPushSubtitle: `Copia esta configuración (textos, modo, OTA y adjuntos) a los alojamientos que elijas.`,
    itemNounWelcome: `el mensaje de bienvenida`,
    arrivalTitleNoun: `instrucciones de llegada`,
    itemNounArrival: `las instrucciones de llegada`,

    // Modo de configuración
    modeConfigLabel: `Modo de configuración`,
    modeSingleTitle: `Mensaje único`,
    modeSingleDesc: `Todas las unidades comparten el mismo mensaje`,
    modeActive: `Activo`,
    modePropertyTitle: `Por propiedad`,
    modePropertyDesc: `Cada unidad tiene su propio mensaje`,
    modePropertyNotice: `Modo individual activo. Edita el mensaje desde cada propiedad.`,

    // Interruptor llegada
    arrivalEnableTitle: `Enviar instrucciones de llegada`,
    arrivalAutoSend: `Se envían automáticamente el día de la llegada{atTime}.`,
    arrivalAtTime: ` a las {time}`,

    // Canales / envío
    deliveryChannels: `Canales de envío`,
    channelEmail: `Email`,
    sendAlsoOta: `Enviar también por OTA`,
    sendTime: `Hora de envío`,

    // Editor
    editorSubtitle: `Configura por idioma. Tip: usa emojis y texto corto.`,
    translateTitle: `Traducir desde {lang} a los demás idiomas`,
    translatingLangLabel: `Traduciendo {lang}…`,
    translatingGeneric: `Traduciendo…`,
    translate: `Traducir`,

    // Adjuntos
    uploading: `Subiendo…`,
    attach: `Adjuntar`,
    emojis: `Emojis`,
    variables: `Variables`,
    variablesHint: `Pulsa para insertarlas. Se reemplazan por los datos reales de la reserva al enviarse.`,
    uploadDone: `Enviado. Guardándolo en el servidor…`,
    uploadSizeProgress: `{done} de {total} MB`,
    attachHint: `Imágenes y PDF hasta {fileMb} MB · Vídeos en MP4 hasta {videoMb} MB.`,
    whatsappLimits: `Son los límites que admite WhatsApp.`,
    openFile: `Abrir {name}`,
    attachmentFallback: `adjunto`,
    delete: `Eliminar`,
    open: `Abrir`,
    arrivalAttachments: `Adjuntos de las instrucciones de llegada`,
    welcomeAttachments: `Adjuntos del mensaje de bienvenida`,
    attachHintFull: `Imágenes y PDF hasta {fileMb} MB · vídeos en MP4 hasta {videoMb} MB. Son los límites que admite WhatsApp.`,
    noAttachments: `No hay adjuntos todavía.`,
    editorSubtitleProperty: `Configura por idioma y adjunta archivos (imágenes, PDF, video).`,

    // Guardar
    saveData: `Guardar datos`,
    saving: `Guardando…`,

    // Resumen de cerraduras
    locksConfigured: `Cerraduras configuradas`,
    accessMethodConfigured: `Método de acceso configurado`,
    guestAccess: `Acceso del huésped`,
    accessDisabledHtml: `El envío de códigos de acceso está <strong>desactivado</strong>, no se incluirá en las instrucciones de llegada.`,
    noAccessMethod: `Aún no hay ningún método de acceso configurado en este alojamiento.`,
    locksHint: `Se configura en la tarjeta «Cerraduras y acceso» del anuncio.`,

    // Vista previa
    online: `en línea`,
    previewDayArrival: `Día de llegada`,
    previewAfterRegister: `Tras el registro`,
    previewPlaceholder: `Escribe el mensaje para ver aquí la vista previa…`,
    previewIncludesAccess: `Incluye el acceso configurado`,
    languageLabel: `idioma {lang}`,
    previewFallbackName: `Tu alojamiento`,
    previewFallbackAccommodation: `tu alojamiento`,

    // Resúmenes de cerradura (computed)
    lockNoteDynamic: `Se genera una clave nueva automática por reserva`,
    lockTagBox: `Código del cajetín`,
    lockTag: `Código`,
    lockCodePending: `Pendiente de configurar el código`,
    lockCodeValue: `{tag}: {code}`,
    lockLabelDefault: `Entrada`,

    // Mensajes de acceso del preview (computed)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*\n\nTu código de acceso es: *58117*\n\nVálido durante tu estancia.`,
    lockMsgBox: `🔑 *{label} · {name}*\n\nEl cajetín de llaves se abre con el código: *{code}*\n\nDentro encontrarás las llaves del alojamiento. Por favor, déjalas de nuevo al salir.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*\n\nEl código de la cerradura es: *{code}*\n\nÚsalo para abrir la puerta del alojamiento.`,

    // Etiquetas de variables (computed)
    varGuestName: `Nombre del huésped`,
    varFullName: `Nombre completo`,
    varCheckinDate: `Fecha de entrada`,
    varCheckoutDate: `Fecha de salida`,
    varCheckinTime: `Hora de check-in`,
    varCheckoutTime: `Hora de check-out`,
    varNights: `Número de noches`,
    varGuests: `Número de huéspedes`,

    // Opciones de cerradura (computed)
    lockOptBoxTitle: `Cajetín con llaves`,
    lockOptBoxDesc: `Las llaves están en un cajetín de seguridad.`,
    lockOptDynamicTitle: `Cerradura inteligente`,
    lockOptDynamicDesc: `Cada reserva crea una clave nueva de forma automática.`,
    lockOptStaticTitle: `Cerradura con código fijo`,
    lockOptStaticDesc: `Un cajetín de llaves o una cerradura con un código fijo.`,

    // Mensaje de llegada por defecto (computed)
    defaultArrivalMessage: `🏡 *Instrucciones de llegada*\n\nHola *{guest}* 👋\n\nAl llegar, dirígete a la entrada principal del alojamiento. 🔑\n\nSi necesitas ayuda, escríbenos por este mismo WhatsApp 📲\n\n¡Feliz estancia! ✨`,

    // Contexto propiedad (heredado)
    inheritedChannelsTitle: `Canales heredados del listing`,
    inheritedListingPrefix: `Esta propiedad usa el welcome centralizado del listing`,
    emailChannel: `Correo electrónico`,
    otaActive: `OTA activa`,
    inheritedNote: `Si quieres cambiar el envío por OTA de este welcome, hazlo desde la configuración del anuncio/listing.`,
    propertyDeliveryTitle: `¿Por dónde se enviará este welcome?`,
    propertyDeliverySubtitle: `Configura los canales de envío para esta propiedad.`,
    propertyDeliveryNote: `Estos canales siguen activos por defecto. Aquí puedes añadir también el envío por OTA para esta propiedad.`,
    otaRowTitle: `Enviar mensajes de bienvenida por OTAs`,
    otaRowText: `Intentará enviar el welcome de esta propiedad por Booking.com y Airbnb usando Channex, con sus adjuntos configurados.`,
    otaRowHint: `Se guarda junto con el mensaje y los adjuntos de bienvenida.`,

    // Toasts / validación
    toastLoadError: `No se pudieron cargar los mensajes.`,
    toastOtaUpdated: `Canal OTA actualizado correctamente`,
    toastOtaError: `No se pudo actualizar el envío por OTA`,
    toastSendTimeUpdated: `Hora de envío actualizada`,
    toastSendTimeError: `No se pudo guardar la hora`,
    toastArrivalEnabled: `Instrucciones de llegada activadas`,
    toastArrivalDisabled: `Instrucciones de llegada desactivadas`,
    toastStatusError: `No se pudo actualizar el estado`,
    toastWelcomeEnabled: `Mensaje de bienvenida activado`,
    toastWelcomeDisabled: `Mensaje de bienvenida desactivado`,
    toastModeUpdated: `Modo actualizado correctamente`,
    toastModeError: `No se pudo actualizar el modo`,
    toastAttachUploaded: `Adjunto(s) subido(s) correctamente`,
    toastAttachUploadError: `Error subiendo adjuntos`,
    toastAttachDeleted: `Adjunto eliminado`,
    toastAttachDeleteError: `No se pudo eliminar el adjunto`,
    toastChangesSaved: `Cambios guardados`,
    toastTranslateEmpty: `Escribe un mensaje en el idioma activo antes de traducir.`,
    toastTranslateSuccess: `¡{count} idiomas traducidos! Revisa cada tab antes de guardar.`,
    toastTranslatePartial: `{success} traducidos, {failed} fallaron. Puedes intentarlo de nuevo.`,
    toastTranslateNone: `No se pudo traducir ningún idioma. Inténtalo de nuevo.`,

    // Errores de validación de archivos (WhatsApp)
    fileErrorVideoFormat: `❌ {name} es un vídeo {ext} y WhatsApp solo admite MP4. Conviértelo a MP4 y vuelve a subirlo.`,
    fileErrorTooBig: `❌ {name} pesa {mb} MB y el máximo son {limMb} MB. `,
    fileErrorTooBigVideo: `WhatsApp no admite vídeos más grandes: comprímelo o recórtalo.`,
    fileErrorTooBigFile: `WhatsApp no admite archivos más grandes.`,
  },
};
